import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";
import { ScreeningPscInspection } from "../../types/Screening";

export const ScreeningPscDetainedBody = (item: ScreeningPscInspection) => {
    const { t } = useTranslation("locale");

    if (item.detained === undefined) {
        return null;
    }

    const isDetained = item.detained === "Y";

    return (
        <span className={classNames({ "psc-detained-yes": isDetained })}>
            {isDetained ? t("psc.yes") : t("psc.no")}
        </span>
    );
};
